const durationLabel = (seconds: number) => {
  if (seconds >= 86_400 && seconds % 86_400 === 0) return `${seconds / 86_400} day`;
  if (seconds >= 60 && seconds % 60 === 0) return `${seconds / 60} min`;
  return `${seconds} sec`;
};

const durationUnitLabel = (seconds: number) => {
  if (seconds >= 86_400 && seconds % 86_400 === 0) {
    return seconds / 86_400 === 1 ? "DAY" : "DAYS";
  }
  if (seconds >= 60 && seconds % 60 === 0) {
    return seconds / 60 === 1 ? "MINUTE" : "MINUTES";
  }
  return seconds === 1 ? "SECOND" : "SECONDS";
};

const parseClockSignature = (signature: string) => {
  if (signature === "unknown") return null;
  // eslint-disable-next-line security/detect-unsafe-regex -- Both numeric fields are bounded and separated by a literal plus.
  const match = signature.match(/^(\d{1,10})(?:\+(\d{1,10}))?$/);
  if (match) {
    return { base: Number(match[1]), increment: Number(match[2] ?? 0) };
  }

  // Chess.com encodes daily controls as days per move over 86400 seconds.
  const dailyMatch = signature.match(/^(\d+)\/(\d+)$/);
  if (!dailyMatch) return null;
  return {
    base: Number(dailyMatch[1]) * Number(dailyMatch[2]),
    increment: 0,
  };
};

export const clockSignatureLabel = (signature: string) => {
  const clock = parseClockSignature(signature);
  if (!clock) return "Unspecified clock";
  return clock.increment > 0 ? `${durationLabel(clock.base)} + ${clock.increment} sec` : durationUnitLabel(clock.base);
};

export const clockSignatureGlyph = (signature: string) => {
  const clock = parseClockSignature(signature);
  if (!clock) return "?";
  const base =
    clock.base >= 86_400 && clock.base % 86_400 === 0
      ? Math.round(clock.base / 86_400)
      : clock.base >= 60 && clock.base % 60 === 0
        ? Math.round(clock.base / 60)
        : clock.base;
  return clock.increment > 0 ? `${base} | ${clock.increment}` : String(base);
};
